export default __webpack_public_path__ + "static/media/cha_healer_kalsit.8da3336a.png";